import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import MultipleRatios from '../../assets/images/landing-page/tikbox_lawyers.png'
import MultipleRatiosMobile from '../../assets/images/landing-page/tikbox_lawyers.png'
import { bookEnterpriseMeeting } from '../../utils/Helper'

const PricingLegal = () => {
  return (
    <div className="pricing-legal">
      <br />
      <h2>CLM for Copyright, Policy, and IP Commercialisation</h2>
      <div>
        <div className="tikbox-row">
          <div className="tikbox-col-6">
            <div className="tikbox-content">
              <p>
                Draft with a contract lifecycle management platform designed
                specifically for copyright lawyers working closely with IP
                owners to protect rights, enforce internal usage policy, streamline collaboration, and unlock
                the commercial value of intellectual property at scale.
              </p>
            </div>
          </div>
          <div className="tikbox-col-6 image">
            <div className="tikbox-content animate__animated animate__fadeIn">
              <img className="desktop" src={MultipleRatios} alt="multiple" />
              <img
                className="mobile"
                src={MultipleRatiosMobile}
                alt="multiple"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="tikbox-services">
        <div className="tikbox-content animate__animated animate__zoomIn">
          <h3>Simple Copyright Contract Builder </h3>
          <p>
            Assistive AI tooling tailored for copyright and policy drafting, review, and
            licensing workflows.{' '}
          </p>
        </div>
        <div className="tikbox-content animate__animated animate__zoomIn">
          <h3>Enterprise Accounts for In-house Legal</h3>
          <p>
            Global and granular contract and policy management designed for complex IP
            portfolios.
          </p>
        </div>
        <div className="tikbox-content animate__animated animate__zoomIn">
          <h3>Secure Copyright and Prevenance</h3>
          <p>
            Legally compliant e- signature supporting secure rights-holder
            collaboration.
          </p>
        </div>
      </div>

      <div className="pricing-legal-benefits">
        <div className="tikbox-row">
          <div className="tikbox-col-6">
            <div className="tikbox-content">
              <h3>Copyright CLM Platform</h3>
              <p>Pricing on demand</p>
              <ul>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>Copyright-focused contract management</span>
                </li>
                  <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>Internal policy document review and enforcement</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>Built for lawyer-IP owner collaboration</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>Advanced governance and security</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>
                    Commercial insight and value tracking (embedded royalty
                    payment tools)
                  </span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <span>Priority onboarding and dedicated support</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="tikbox-col-6">
            <div className="tikbox-content">
              <button onClick={bookEnterpriseMeeting}>Book a Demo</button>
              <button onClick={bookEnterpriseMeeting}>Contact Sales</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingLegal
